<div class="container mx-lg-0 mt-4">
    <div class="line d-block d-lg-none"></div>
    <div class="summary-project">

        <h4 class="fw-sbold cl-black"></h4>
        <div #textContainer class="d-block d-lg-none overflow-hidden position-relative text-container" [ngClass]="{'expanded': isExpanded}">
            <h6 class="description lh-base cl-black" [innerHTML]="infoProject?.description | safeHtml"></h6>
            <a (click)="toggleExpand()" *ngIf="textContainer.scrollHeight > textContainer.clientHeight" class="expand-link">
              <strong>{{ buttonText }}</strong>
            </a>
        </div>
        <div class="d-none d-lg-block overflow-hidden position-relative">
            <h6 class="description fs-14 lh-base cl-black" [innerHTML]="showFullText ? fullText : truncatedText | safeHtml"></h6>
            <a *ngIf="isTextTruncated" (click)="toggleFullText()" class="expand-link">
                <span class="cl-new-primary fs-14 cr-pointer fw-sbold">{{ showFullText ? 'Leer menos' : 'Leer más' }}</span>
            </a>
        </div>
    </div>
    <div class="line d-block d-lg-none"></div>
    <div class="info-data-project">
        <div class="row row-cols-1 row-cols-lg-2">
            <div class="col-lg-6 col-12">
                <div class="col-12 info-line">
                    <div class="d-flex justify-content-between">
                        <div class="row">
                            <div class="icon col-1"><img src="/assets/img/icon/inital-invest-icon.svg" alt="inital-invest-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                            <div class="col mt-1"><h6>Tipo de proyecto:</h6></div>
                        </div>
                        <div><div class="col mt-1"><h6 class="text-end fw-sbold" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ getProjectStateText(infoProject?.actualState) | titlecase }}</h6></div></div>
                    </div>
                </div>
                <div class="col-12 info-line">
                    <div class="d-flex justify-content-between">
                        <div class="row">
                            <div class="icon col-1"><img src="/assets/img/icon/time-icon.svg" alt="time-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                            <div class="col mt-1"><h6>{{ infoProject?.actualState == 'fixed' ? 'Plazo:' : 'Plazo estimado:' }}</h6></div>
                        </div>
                        <div><div class="col mt-1"><h6 class="text-end fw-sbold" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ infoProject?.monthsEstimateResidential }}</h6></div></div>
                    </div>
                </div>
                <div class="col-12 info-line" *ngIf="infoProject?.actualState == 'fixed'">
                    <div class="d-flex justify-content-between">
                        <div class="row">
                            <div class="icon col-1"><img src="/assets/img/icon/wallet-icon.svg" alt="wallet-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                            <div class="col mt-1"><h6>Rendimiento anual fijo:</h6></div>
                        </div>
                        <div><div class="col mt-1"><h6 class="text-end fw-sbold" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ infoProject?.performance }} %</h6></div></div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-12">
                <div class="col-12 info-line">
                    <div class="d-flex justify-content-between">
                            <div class="row">
                                <div class="icon col-1"><img src="/assets/img/icon/tag-icon.svg" alt="tag-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                                <div class="col mt-1"><h6>Invierte desde:</h6></div>
                            </div>
                            <div><div class="col mt-1"><h6 class="text-end fw-sbold" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">${{ infoProject?.phase?.partValue || 1000 | number }}</h6></div></div>
                    </div>
                </div>
                <div class="col-12 info-line">
                    <div class="d-flex justify-content-between">
                            <div class="row">
                                <div class="icon col-1"><img src="/assets/img/icon/calendar-icon.svg" alt="calendar-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                                <div class="col mt-1"><h6>Frecuencia de repartos:</h6></div>
                            </div>
                            <div><div class="col mt-1"><h6 class="text-end fw-sbold" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ infoProject?.capitalization }}</h6></div></div>
                    </div>
                </div>
                <div class="col-12 info-line" *ngIf="infoProject?.actualState == 'fixed'">
                    <div class="d-flex justify-content-between">
                        <div class="row">
                            <div class="icon col-1"><img src="/assets/img/icon/tir-icon.svg" alt="tir-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                            <div class="col mt-1"><h6>TIR anual:</h6></div>
                        </div>
                        <div><div class="col mt-1"><h6 class="text-end fw-sbold" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ infoProject?.TIRAnual || 0 }} %</h6></div></div>
                    </div>
                <div class="evaluation-container d-flex d-lg-none pb-0">
                    <div class="row">
                        <div class="col-12 ps-1">
                            <div class="d-flex align-items-center h-100">
                                <div class="icon mb-2"><img width="17" src="/assets/img/icon/search-icon.svg" alt="search-icon" class="icon-svg" [ngClass]="{'cl-primary-card': infoProject?.actualState == 'fixed', 'cl-secondary-card': infoProject?.actualState != 'fixed'}"></div>
                                <div class="col ms-2 mt-1"><h6>Evaluación Monific:</h6></div>
                            </div>
                        </div>
                    </div>
                    <div class="letter-container ms-5">
                      <div class="letter" [ngClass]="getLetterClass()">{{ infoProject?.ratingProject }}</div>
                      <div class="lines">
                        <div class="line rb-back"></div>
                        <div class="line mb-back"></div>
                        <div class="line rm-back"></div>
                        <div class="line ra-back"></div>
                      </div>
                    </div>
                </div>
                <div class="d-flex d-lg-none align-items-center justify-content-end">
                    <a target="_blank" (click)="openLink('https://centrodeayuda.monific.com/qu%C3%A9-es-la-evaluaci%C3%B3n-monific')"><p class="cl-black fs-13 me-1 text-decoration-underline">Leer más</p></a>
                </div>
            </div>
        </div>
    </div>
    <div class="line d-block d-lg-none"></div>
</div>